/* Cómo se escribe una dirección, en un solo lugar.
 *
 * ── POR QUÉ ESTÁ ACÁ Y NO ADENTRO DEL COMPONENTE ─────────────────────────
 *
 * El bot contesta «¿dónde vive Lucero?» por WhatsApp y el hub la dibuja en la
 * ficha. Son dos programas distintos leyendo la MISMA fila. Si cada uno arma
 * la línea a su manera, la dirección que llega al celular y la que está en
 * pantalla se leen como dos datos —«¿le puse el piso o no?»— cuando son el
 * mismo. La versión de Python vive en `ficha_chofer.como_direccion()` y esta
 * es su gemela; el test de abajo compara las dos con la misma tabla.
 *
 * ── LOS CAMPOS VACÍOS NO DEJAN CICATRIZ ──────────────────────────────────
 *
 * De las 288 filas cargadas, la mayoría no tiene piso ni departamento: son
 * casas. Un «· piso  dto » colgando, o un « — , CP » al final, hacen que una
 * dirección completa parezca a medio cargar. Cada tramo entra sólo si tiene
 * algo adentro.
 */
export function comoDireccion(d) {
  if (!d) return "";
  const t = (k) => String(d[k] ?? "").trim();

  let base = t("domicilio");
  if (!base) return "";              // sin calle no hay dirección que mostrar

  const piso = t("piso");
  const dto = t("dto");
  const detalle = [piso && `piso ${piso}`, dto && `dto ${dto}`].filter(Boolean);
  if (detalle.length) base += ` · ${detalle.join(" ")}`;

  const cp = t("cp");
  const cola = [t("localidad"), cp && `CP ${cp}`].filter(Boolean).join(", ");
  return cola ? `${base} — ${cola}` : base;
}

export default comoDireccion;
